
let runtime: {
  mapboxgl: any;
  version: 'v2' | 'v3';
  cssLoaded: boolean;
} | null = null;

function detectVersion(mapbox: any): 'v2' | 'v3' {
  const ver = mapbox.version || '';
  return ver.startsWith('3') ? 'v3' : 'v2';
}

function loadMapboxCSS(version: 'v2' | 'v3') {
  if (document.getElementById('mapbox-css')) return;

  const link = document.createElement('link');
  link.id = 'mapbox-css';
  link.rel = 'stylesheet';
  link.href = version === 'v3'
    ? 'https://api.mapbox.com/mapbox-gl-js/v3.1.1/mapbox-gl.css'
    : 'https://api.mapbox.com/mapbox-gl-js/v2.15.0/mapbox-gl.css';

  document.head.appendChild(link);
}

export function setMapbox(mapbox: any) {
  const version = detectVersion(mapbox);
  loadMapboxCSS(version);
  runtime = {
    mapboxgl: mapbox,
    version,
    cssLoaded: true
  };
}

export function getMapbox(noOfTries: number = 3) {
  if (!runtime) {
    if (noOfTries)
      setTimeout(() => {
        this.getMapbox(noOfTries--);
      }, 1000)
    else throw new Error('Mapbox not loaded yet');
  }
  return runtime;
}

export const mapboxglref = () => getMapbox().mapboxgl;
export const mapboxVersion = () => getMapbox().version;
export const isCSSLoaded = () => getMapbox().cssLoaded;